import React from "react";
import {Link} from "react-router-dom";

function Button(props) {
    return (
        <>
            <style jsx={"true"}>{`
                .carousel-btn {
                    padding: 12px 30px;
                    background-color: #DBA800;
                    color: white;
                    border: none;
                    border-radius: 5px;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    text-decoration: none;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                .carousel-btn:hover {
                    background-color: #c29600;
                    transform: translateY(-3px);
                }

                .carousel-btn.outline {
                    background-color: transparent;
                    border: 2px solid white;
                }

                .carousel-btn.outline:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                }

                @media (max-width: 768px) {
                    .carousel-btn {
                        padding: 10px 20px;
                    }
                }
            `}</style>
            <Link
                to={props.to}
                className={props.btnType === "primary" ? "carousel-btn auto-primary" : "carousel-btn outline auto-secondary"}
            >
                {props.btnName}
            </Link>
        </>
    );
}

export default Button;